var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4 text-center page-404"},[_c('span',{staticStyle:{"color":"E2001A"}},[_vm._v("404")]),_c('h2',[_vm._v("Page Not Found")])])}]

export { render, staticRenderFns }